module.exports = __webpack_public_path__ + "fonts/SourceSerifPro-Regular.ttf!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSerifPro-Regular.ttf
// module id = 46
// module chunks = 0